export { default } from 'crehana-ui/LazyImage';
